import { useState,useEffect } from "react";
import { ApiAddNotificationSetting, ApiUpdateNotificationSettings,ApiDeleteNotificationSettings } from "../../../../../../Api";
import { NOTIFICATION_SETTINGS_TYPES } from "../../../../../../Constants/NotificationSettingTypes";
import { SettingSMSInput } from "./SettingSMSInput";


export function SMSSettings({ reloadData, sms }) {

    const [stateError, setStateError] = useState();
    const [phoneError, setPhoneError] = useState();

    const [mainInputValue, setMainInputValue] = useState({
        value: '',
        active: false
    });

    function addNotificationPhone(
        receiver,
        isActive,
        type
    ) {
        const sendingData = {
            receiver,
            type,
            isActive
        }
        return ApiAddNotificationSetting(sendingData)
            .then(() => {
                reloadData();
            })
            .catch((error) => {
                setPhoneError(error?.response?.data?.error?.message)
            })
    }

    function updateNotificationPhone(
        id,
        receiver,
        isActive,
        type
    ) {
        const sendingData = {
            receiver,
            type,
            isActive
        }
        return ApiUpdateNotificationSettings(id, sendingData)
            .then(() => {
                reloadData();
            })
            .catch((error) => {
                setPhoneError(error?.response?.data?.error?.message)
            })
    }

    function deleteNotificationPhone(
        id
    ) {
        return ApiDeleteNotificationSettings(id)
            .then(() => {
                reloadData();
            });
    }

    const deleteErrorButton = (fieldKey) => {
        if (fieldKey) {
            setStateError(null)

        }
    };

    useEffect(() => {
        if (phoneError) {
            setStateError(phoneError);
        }
    }, [phoneError]);

    return (
        <>
            <div className="password__change__block">
                <div className="alerts__input__box__all">
                {phoneError ?
                    <span className='settings_error_message'>{stateError}</span> : null
                }
                    {
                        sms?.map((dt, index) => {
                            return <SettingSMSInput placeholder={'Phone SMS'} id={index} key={index} value={dt.receiver} active={dt.isActive} action={(e) => {
                           return  updateNotificationPhone(dt.id, e.value, e.active, NOTIFICATION_SETTINGS_TYPES.SMS);
                            }}
                            onDelete={() => {
                                deleteNotificationPhone(dt.id);
                            }} 
                            />
                        })
                    }
                    <SettingSMSInput main={true} placeholder={'Phone SMS'} id="main" value={mainInputValue.value} active={mainInputValue.active}
                      focus={(event) => {
                        deleteErrorButton(event)
                    }} 
                    action={(e) => {
                    return addNotificationPhone(e.value, e.active, NOTIFICATION_SETTINGS_TYPES.SMS);
                    }} />
                </div>
            </div>
        </>
    )
}